import { ChatMessage, ChatRole, isTextContent} from '../../../libs/models/conversations/ChatMessage';
import { ChatHistoryItem } from './ChatHistoryItem';
import React from 'react';

interface ChatHistoryItemsProps {
  item: ChatMessage;
  messageIndex: number;
  botStatus: boolean;
  isLast: boolean;
  isTest?: boolean;
}

export const ChatHistoryItems: React.FC<ChatHistoryItemsProps> = ({
  item,
  messageIndex,
  botStatus,
  isLast,
  isTest,
}) => {
  const isMe = item.role === ChatRole.User;
  const isBot = item.role === ChatRole.System || item.role === ChatRole.Assistant;
  const canRetry = isBot && isLast && !item.resultMeta?.hasError;
  const isTyping = botStatus && isLast && !item.contents?.some(c=>isTextContent(c));
  const showProgress = botStatus && isLast && !!item.progress?.items?.some((s) => !s.isCompleted);
  const [currentItemId, setCurrentItemIndex] = React.useState(item.preMessages ? item.preMessages.length : 0);

  React.useEffect(()=> {
    setCurrentItemIndex(item.preMessages ? item.preMessages.length : 0);
  },[item.preMessages?.length])

  // user / tool 턴에 functionResult/toolApprovalResponse 가 포함된 메시지는 미노출 (사용자 응답 echo).
  // assistant 턴은 결과 카드로 보여줘야 하므로 숨기지 않는다.
  if (((item.role as string) === 'tool' || item.role === ChatRole.User) && item.contents?.some(
    (c) => {
      const t = (c as { $type?: string }).$type;
      return t === 'functionResult' || t === 'toolApprovalResponse';
    },
  )) {
    return null;
  }

  return (
    <ChatHistoryItem
      item={item}
      messageIndex={messageIndex}
      currentItemId={currentItemId}
      setCurrentItemIndex={setCurrentItemIndex}
      isMe={isMe}
      isBot={isBot}
      canRetry={canRetry}
      isTyping={isTyping}
      showProgress={showProgress}
      isTest={isTest}
    />
  );
};
